export default "__VITE_ASSET__DbWWBCU7__"